import { Avatar, Box, ButtonBase, Stack, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import { styleSets } from '@/components/styles'
import { useRouter } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

import { Rank } from './../Rank'

export type RankListItemProps = {
  displayName: string
  avatarUrl: string
  rank: number
  point: number
  userId?: string
}

export const RankListItem: Organism<RankListItemProps> = ({
  displayName,
  avatarUrl,
  rank,
  point,
  userId,
}) => {
  const { generatePath, routerPages } = useRouter()
  return (
    <OrganismFrame>
      <ButtonBase
        sx={{
          width: '100%',
          bgcolor: 'grey.100',
          height: 72,
          borderRadius: 1,
          overflow: 'hidden',
        }}
        href={
          userId
            ? generatePath(routerPages.ArtistRanking, {
                artistId: userId,
              })
            : '#'
        }
      >
        <Stack direction="row" flex={1} sx={{ minWidth: 0 }} spacing={3}>
          <Box sx={{ position: 'relative' }}>
            <Avatar
              variant="square"
              sx={{ width: 72, height: 72 }}
              src={avatarUrl ?? ''}
            />
            <Box
              sx={{
                width: 22,
                height: 72,
                position: 'absolute',
                top: 0,
                right: 0,
                backgroundImage: ({ palette }) =>
                  `linear-gradient(to bottom right, transparent 50%, ${palette.grey['100']} 0)`,
              }}
            />
          </Box>
          <Stack
            flex={1}
            alignItems="center"
            justifyContent="center"
            spacing={2}
            sx={{ minWidth: 0 }}
          >
            <Typography
              variant="subtitle1"
              align="center"
              sx={{ ...styleSets.lineCamp(1), width: '100%' }}
            >
              {displayName}
            </Typography>
            <Stack
              sx={{
                bgcolor: 'grey.50',
                borderRadius: 3,
                width: 80,
                height: 20,
                position: 'relative',
              }}
              alignItems="center"
              justifyContent="center"
            >
              <Typography variant="subtitle1" sx={{ mt: '2px' }}>
                {point || '---'}
              </Typography>
              <Icons.EventPoint
                sx={{ position: 'absolute', left: -4, top: -2 }}
              />
            </Stack>
          </Stack>
          <Rank rank={rank ?? 0} size="large" sx={{ pr: 1 }} />
        </Stack>
      </ButtonBase>
    </OrganismFrame>
  )
}
